/**
 * Maldivian rufiyaa.
 */
export var MVR = {
  code: 'MVR',
  base: 10,
  exponent: 2
};